import { type RouteRecordRaw, createRouter, createWebHashHistory } from "vue-router";
import authRoutes from "@/routes/authRoutes";
import userRoutes from "@/routes/userRoutes";
import EatTopBar from "@/layout/partials/EatTopBar.vue";
import OrderTopBar from "@/views/order/partials/TopBar.vue";
import PaymentError from "@/views/cart/PaymentError.vue";
import PaymentSuccess from "@/views/cart/PaymentSuccess.vue";
import Cart from "@/views/cart/Cart.vue";
import Checkout from "@/views/cart/Checkout.vue";
import TakeawayOnSiteOrder from "@/views/order/TakeawayOnSiteOrder.vue";
import CrossSellingCategories from "@/views/cart/CrossSellingCategories.vue";
import PaymentPending from "@/views/cart/PaymentPending.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: { name: "order" }
  },
  {
    path: "/order",
    name: "order",
    components: {
      topBar: OrderTopBar,
      default: TakeawayOnSiteOrder
    },
    meta: { mainView: true }
  },
  {
    path: "/cart",
    name: "cart",
    components: {
      topBar: EatTopBar,
      default: Cart
    },
    meta: { mainView: true, showMoreButton: true, topBarBorderBottom: true }
  },
  {
    path: "/cart/cross-selling",
    name: "cart.crossSelling",
    components: {
      topBar: EatTopBar,
      default: CrossSellingCategories
    },
    meta: { showBackButton: true, topBarBorderBottom: true }
  },
  {
    path: "/cart/checkout",
    name: "cart.checkout",
    components: {
      topBar: EatTopBar,
      default: Checkout
    },
    meta: {
      showBackButton: true,
      topBarBorderBottom: true
    }
  },
  {
    path: "/pagamento/successo",
    name: "payment.success",
    components: {
      default: PaymentSuccess
    },
    meta: {
      hideNavbar: true,
      doNotSaveToHistory: true,
    }
  },
  {
    path: "/pagamento/elaborazione",
    name: "order.pending",
    components: {
      default: PaymentPending
    },
    meta: {
      hideNavbar: true,
      doNotSaveToHistory: true
    }
  },
  {
    path: "/pagamento/fallito",
    name: "payment.error",
    components: {
      default: PaymentError
    },
    meta: {
      hideNavbar: true,
      doNotSaveToHistory: true
    }
  },
  ...userRoutes,
  ...authRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: "order" }
  }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;